import * as firebase from 'firebase'
import {tidyObj} from "../helpers.js"
import DocumentData from '../../data/Document.json'

export default {
  state: {
      documents:[]
      },
  mutations: {
    setDocument(state,payload){
      var found=false;
      for(var i in state.documents ){
        if(state.documents[i].id==payload.id){
          found=true
          state.documents[i]=payload.content
        } 
      }
      if(!found){
        state.documents.push(payload.content)
      }
    }
  },
  actions: {
    loadAllDocs({commit}){
      commit('loadingText',true)
      let data
      let doc

      
      var db = firebase.firestore();
      var colRef = db.collection("Documents")
      colRef.get().then(function(docs) {
        for(var d in docs.docs){
          doc=docs.docs[d]
          data=doc.data()
          data.id=doc.id
          console.log("Documents",doc)
          commit('setDocument',{id:doc.id,content:tidyObj(data)}) 
        }
         
          commit('loadingText',false)
      }).catch(function(error) {
          console.log("Error getting document:", error);
          commit('loadingText',false)
        });
      
    },

    loadDoc({ commit ,getters},payload){
      commit('loadingText',true)
      let data
        if(DocumentData && DocumentData[payload]){
          commit('loadingText',false)
          data=DocumentData[payload]
          data.id=payload
          console.log("HAS READ",getters.getViewedDocs,payload)
          data.read=getters.getViewedDocs.includes(payload)
          console.log("PRE TIDY",DocumentData[payload])
          commit('setDocument',{id:payload,content:tidyObj(DocumentData[payload])}) 
          return
      }
      var db = firebase.firestore();
      var docRef = db.collection("Documents").doc(payload)
      docRef.get().then(function(doc) {
        data=doc.data()
        data.id=payload
        console.log("HAS READ",getters.getViewedDocs,payload)
        data.read=getters.getViewedDocs.includes(payload)
          commit('loadingText',false)
          
          commit('setDocument',{id:payload,content:tidyObj(data)}) 
      }).catch(function(error) {
          console.log("Error getting document:", error);
          commit('loadingText',false)
        });
    }
  },
  getters: {
    getDocument: state => id => {
        for(var document in state.documents){
            if(state.documents[document].id==id){
                return state.documents[document]
            }
        }
        return {name:"Missing Doc "+id,id: id,image:"bomberBP.png",ratio:1.54}
    },
    getDocuments(state){
      return state.documents
    }
  }
}

